import Typography, { TypographyProps } from '@material-ui/core/Typography';
// eslint-disable-next-line
import React from 'react';

export type Props = TypographyProps;

const FormSubTitle: React.FC<Props> = ({ children, ...rest }) => {
  return (
    <Typography
      color="textSecondary"
      gutterBottom
      variant="caption"
      component="h2"
      {...(rest as any)}
    >
      {children}
    </Typography>
  );
};

export default FormSubTitle;
